import React from 'react'
import Card from './Card';
import { motion } from 'framer-motion';

const Projects = () => {
    const cards = [
      {
        imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9sfzkeKDFaNRKuH_nGu2Th2rbSp32aQAWhw&s", // Replace with real image URL
        altText: 'TV Application Solution',
        title: 'TV Application',
        description: 'A TV application for Samsung, LG , Android, that integrates content streaming and live TV channels, developed for seamless user experience.(Volej TV)',
        explore:"https://volej.tv/"  // Example URL, replace with your actual project link
      },
      {
        imageUrl: "https://healthnutla.com/wp-content/uploads/catering-1-2048x624.webp", // Replace with real image URL
        altText: 'Healthnut LA Website',
        title: 'Healthnut LA',
        description: 'A wellness and nutrition-focused website for Healthnut LA, showcasing their services, blog, and health resources.(Appentus)',
        explore:"https://healthnutla.com/"  // Example URL, replace with your actual project link
      },
      {
        imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQXs3NUxthtVQyj5VU7ycWssGqWGUxJB7GFA&s", // Replace with real image URL
        altText: 'Teesas Website',
        title: 'Teesas Web Platform',
        description: 'A learning platform for Teesas, offering interactive educational content, resources, and quizzes for students.(Appentus)',
        explore:"https://www.teesas.com/"  // Example URL, replace with your actual project link
      },
      {
        imageUrl: "https://d2s742iet3d3t1.cloudfront.net/restaurants/restaurant-245489000000000000/restaurant/images/rest-497dd023-078b-4135-b532-c613e3a22165.jpg?size=medium", // Replace with real image URL
        altText: 'Hotbox Cookies',
        title: 'Hotbox Cookies eCommerce Website',
        description: 'An eCommerce website for Hotbox Cookies, offering online ordering, menu management, and customer reviews.(Appentus)',
        explore:"https://www.hotboxcookies.com/"  // Example URL, replace with your actual project link
      },
      
      {
        imageUrl: "https://play-lh.googleusercontent.com/wIOQ_RRFM3hPcfCoxNoHkedSpHdQ0tujLozxGcTY0mgyjEJaABp03_8zA4PUPriNEII=w240-h480-rw", // Replace with real image URL
        altText: 'Towtap Application',
        title: 'Towtap Application',
        description: '**This is the Tow Truck Driver version, users use towtap.com.au** Australia’s first on-demand tow truck app platform! Simply input where your car is located and where you want your car taken to.',
        explore: "https://play.google.com/store/apps/details?id=com.towtapdriver&hl=en_IN"  // Example URL, replace with your actual project link
    },
    
        {
          imageUrl: "https://sail.co.in/sites/default/files/2024-08/sailbanner.jpg", // Replace with real image URL
          altText: 'SAIL Website',
          title: 'SAIL Corporate Website',
          description: 'A dynamic and informative corporate website for Steel Authority of India Limited (SAIL), featuring their services, news, and updates.(Appentus)',
          explore:"https://www.sail.co.in/en"  // Example URL, replace with your actual project link
        },
        {
          imageUrl: "https://ongcindia.com/o/ongc-india-inner/images/innerBanner.jpg", // Replace with real image URL
          altText: 'ONGC App',
          title: 'ONGC Employee Portal',
          description: 'A web-based portal designed for ONGC employees, providing them with access to resources, training, and internal tools.(Appentus)',
          explore:"https://ongcindia.com/web/eng"  // Example URL, replace with your actual project link
        },
        {
          imageUrl: "https://play-lh.googleusercontent.com/KGCWUrS1dnoI2sSeHYCfqa8w2YL5AVl9qXKgdYOqEF-O5piW55Pj8CnD29jAbV7qVw=w480-h960-rw", // Replace with real image URL
          altText: 'JVVNL App',
          title: 'JVVNL',
          description: 'A service app for Jaipur Vidyut Vitaran Nigam Limited (JVVNL), allowing users to manage their electricity bills and services.(Appentus)',
          explore:"https://play.google.com/store/apps/details?id=com.jvvnl.agri&hl=en_IN"  // Example URL, replace with your actual project link
        },
        
    ];

    return (
        <motion.div
            initial={{
                opacity: 0,
                y: 40
            }}
            whileInView={{
                opacity: 1,
                y: 0
            }}
            transition={{
                delay: 0.2,
                duration: 0.5
            }}
            viewport={{
                margin: "-100px",
                once: true
            }}
            className="up_gap"
            id="project"
        >
            <h2 className='heading1 down_gap'>Projects</h2>
            <div className="completely">
                <div className="grid">
                    {cards.map((card, index) => (
                        <Card
                            key={index}
                            imageUrl={card.imageUrl}
                            altText={card.altText}
                            title={card.title}
                            description={card.description}
                            explore={card.explore}
                        />
                    ))}
                </div>
            </div>
        </motion.div>
    )
}

export default Projects;
